import FormPicklistField from "components/atoms/FormPicklistField";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const GET_DOMAIN_DATA_RESULT = { success: null, inProgress: true };
const DOMAIN_DATA_RESULT = { Items: [] };

export class FormDomainDataPicklistField extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.props.getPicklistDomainData(this.props.dataDomainId, null);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.dataDomainId !== this.props.dataDomainId) {
            this.props.getPicklistDomainData(this.props.dataDomainId, null);
        }
    }

    render() {
        return (
            <FormPicklistField
                {...this.props}
                disabled={this.props.disabled}
                fetchingData={this.props.getDomainDataResult?.inProgress ?? true}
                items={this.props.domainDataResult?.Items ?? []}
            ></FormPicklistField>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const domainState = state.formDomainDataPicklistField.domainData[ownProps.dataDomainId];

    return {
        getDomainDataResult: domainState?.getDomainDataResult ?? GET_DOMAIN_DATA_RESULT,
        domainDataResult: domainState?.domainDataResult ?? DOMAIN_DATA_RESULT,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPicklistDomainData: (dataDomainId, pageKey) => dispatch(actions.getPicklistDomainDataRequest(dataDomainId, pageKey)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FormDomainDataPicklistField));
